import DropdownCheckbox from "components/DropdownCheckbox";
import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import {
  BPEStore,
  Option,
} from "features/BuildingProductEditor/ProductEditorStore";

export default observer(function DataSourceFilter({
  selected,
  setSelected,
  removingItem,
  handleRemoveItem,
  disabled,
}: {
  selected?: Option[];
  setSelected: React.Dispatch<React.SetStateAction<Option[]>>;
  removingItem: Option | undefined;
  handleRemoveItem: () => void;
  disabled?: boolean;
}) {
  const { t } = useTranslation();

  React.useEffect(() => {
    (async () => {
      await BPEStore.fetchEPDDatabases();
    })();
  }, []);

  const onChangeCategories = (value: Option[]) => setSelected(value);

  if (!BPEStore.filtersOptions.epd_data_sources) return <></>;
  return (
    <DropdownCheckbox<Option>
      displayKey={"name"}
      required={true}
      handleSelect={onChangeCategories}
      labelName={t("mapping.dataSource")}
      name="epd_data_sources"
      items={BPEStore.filtersOptions.epd_data_sources}
      removeSelected={removingItem}
      handleRemoveSelected={handleRemoveItem}
      containerClassName="mr-0 sm:mr-3 min-w-[146px] !mb-3"
      optionsClassName="z-40 !max-w-fit"
      checkedItems={selected}
      disabled={disabled}
    />
  );
});
